import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { MY_DAY_TODAYS_MEALS_ROUTE } from '../../services/routes';
import MyDayCompactMealCard from './my_day_compact_meal_card';
import { useGetDbPlannerWeekQuery } from '../../app/smorgAppSyncGraphQLApi';
import {
  dbWeekStartDateStr,
  plannerEntriesInCalendarDay,
} from '../../services/planner';
import { PlannerEntryType } from '../../API';
import MyDayPlaceholderSection from './my_day_placeholder_section';

const MyDayTodaysMealsSection = ({ today }) => {
  const dbWeekStartDate = dbWeekStartDateStr(today);

  const { data: dbPlannerWeek, isSuccess: isPlannerWeekSuccess } =
    useGetDbPlannerWeekQuery(dbWeekStartDate);

  const todaysMealPlannerEntries = plannerEntriesInCalendarDay(
    dbPlannerWeek,
    today,
  ).filter(
    (plannerEntry) =>
      !plannerEntry.plannerEntryType ||
      plannerEntry.plannerEntryType === PlannerEntryType.MEAL,
  );

  if (!isPlannerWeekSuccess) {
    return <MyDayPlaceholderSection title="Loading meals..." />;
  }

  if (isPlannerWeekSuccess && todaysMealPlannerEntries.length === 0) {
    return null;
  }
  return (
    <>
      <Grid container>
        <Grid item xs={8}>
          <h2
            style={{
              margin: '23px 23px 5px',
              color: 'var(--app-primary-font-color)',
            }}>
            Today&apos;s meals
          </h2>
        </Grid>
        <Grid
          item
          xs={4}
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}>
          <Box sx={{ margin: '28px 10px 5px' }}>
            <Link to={MY_DAY_TODAYS_MEALS_ROUTE}>View all</Link>
          </Box>
        </Grid>
      </Grid>

      <div style={{ overflowX: 'auto', display: 'flex' }}>
        {todaysMealPlannerEntries.map((plannerEntry) => (
          <div key={plannerEntry.mealID} style={{ flexShrink: 0 }}>
            <MyDayCompactMealCard
              mealID={plannerEntry.mealID}
              parentID={dbPlannerWeek.id}
              calendarDay={today}
            />
          </div>
        ))}
      </div>
    </>
  );
};

MyDayTodaysMealsSection.propTypes = {
  today: PropTypes.string.isRequired,
};

export default MyDayTodaysMealsSection;
